"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.taskStatusToGroupMapping = exports.taskGroupToStatusMapping = exports.CUSTOMER_STATUS_TO_ACUMEN_STATUS = exports.CUSTOMER_TYPE_TO_ACUMEN_TYPE = exports.DevelopmentMethodology = exports.TaskEstimationMethod = exports.IssueChangelogEventType = exports.AcumenTaskCustomField = exports.AcumenTaskStatusGroup = exports.AcumenTaskType = exports.AcumenTaskStatus = exports.TaskIntegrationType = void 0;
var TaskIntegrationType;
(function (TaskIntegrationType) {
    TaskIntegrationType["JIRA"] = "JIRA";
})(TaskIntegrationType = exports.TaskIntegrationType || (exports.TaskIntegrationType = {}));
var AcumenTaskStatus;
(function (AcumenTaskStatus) {
    AcumenTaskStatus["Backlog"] = "Backlog";
    AcumenTaskStatus["Selected for Development"] = "Selected for Development";
    AcumenTaskStatus["In Progress"] = "In Progress";
    AcumenTaskStatus["Blocked"] = "Blocked";
    AcumenTaskStatus["Code Review"] = "Code Review";
    AcumenTaskStatus["To Test"] = "To Test";
    AcumenTaskStatus["Testing"] = "Testing";
    AcumenTaskStatus["Client Review"] = "Client Review";
    AcumenTaskStatus["Done"] = "Done";
    AcumenTaskStatus["Closed"] = "Closed";
    AcumenTaskStatus["Discarded"] = "Discarded";
})(AcumenTaskStatus = exports.AcumenTaskStatus || (exports.AcumenTaskStatus = {}));
var AcumenTaskType;
(function (AcumenTaskType) {
    AcumenTaskType["Sub-Task"] = "Sub-Task";
    AcumenTaskType["Bug"] = "Bug";
    AcumenTaskType["Epic"] = "Epic";
    AcumenTaskType["Change Request"] = "Change Request";
    AcumenTaskType["Improvement"] = "Improvement";
    AcumenTaskType["New Feature"] = "New Feature";
    AcumenTaskType["Story"] = "Story";
    AcumenTaskType["Task"] = "Task";
    AcumenTaskType["Technical Task"] = "Technical Task";
    AcumenTaskType["Support"] = "Support";
    AcumenTaskType["Security"] = "Security";
    AcumenTaskType["Documentation"] = "Documentation";
})(AcumenTaskType = exports.AcumenTaskType || (exports.AcumenTaskType = {}));
var AcumenTaskStatusGroup;
(function (AcumenTaskStatusGroup) {
    AcumenTaskStatusGroup["Backlog"] = "Backlog";
    AcumenTaskStatusGroup["InProgress"] = "InProgress";
    AcumenTaskStatusGroup["Done"] = "Done";
})(AcumenTaskStatusGroup = exports.AcumenTaskStatusGroup || (exports.AcumenTaskStatusGroup = {}));
var AcumenTaskCustomField;
(function (AcumenTaskCustomField) {
    AcumenTaskCustomField["Sprint"] = "SPRINT";
    AcumenTaskCustomField["StoryPoints"] = "STORY_POINTS";
    AcumenTaskCustomField["Rank"] = "RANK";
    AcumenTaskCustomField["TShirtSize"] = "TSHIRT_SIZE";
    AcumenTaskCustomField["Flagged"] = "FLAGGED";
})(AcumenTaskCustomField = exports.AcumenTaskCustomField || (exports.AcumenTaskCustomField = {}));
var IssueChangelogEventType;
(function (IssueChangelogEventType) {
    IssueChangelogEventType["Assigned"] = "ASSIGNED";
    IssueChangelogEventType["StatusChanged"] = "STATUS_CHANGED";
    IssueChangelogEventType["Attachment"] = "ATTACHMENT";
    IssueChangelogEventType["CommentDeleted"] = "COMMENT_DELETED";
    IssueChangelogEventType["Component"] = "COMPONENT";
    IssueChangelogEventType["Description"] = "DESCRIPTION";
    IssueChangelogEventType["DueDate"] = "DUE_DATE";
    IssueChangelogEventType["Environment"] = "ENVIRONMENT";
    IssueChangelogEventType["FixVersions"] = "FIX_VERSIONS";
    IssueChangelogEventType["IssueType"] = "ISSUE_TYPE";
    IssueChangelogEventType["Labels"] = "LABELS";
    IssueChangelogEventType["Priority"] = "PRIORITY";
    IssueChangelogEventType["Project"] = "PROJECT";
    IssueChangelogEventType["Reporter"] = "REPORTER";
    IssueChangelogEventType["Resolution"] = "RESOLUTION";
    IssueChangelogEventType["ResolutionDate"] = "RESOLUTION_DATE";
    IssueChangelogEventType["Summary"] = "SUMMARY";
    IssueChangelogEventType["OriginalTimeEstimate"] = "ORIGINAL_TIME_ESTIMATE";
    IssueChangelogEventType["TimeEstimate"] = "TIME_ESTIMATE";
    IssueChangelogEventType["TimeSpent"] = "TIME_SPENT";
    IssueChangelogEventType["Versions"] = "VERSIONS";
    IssueChangelogEventType["SprintChanged"] = "SPRINT_CHANGED";
    IssueChangelogEventType["StoryPoints"] = "STORY_POINTS";
    IssueChangelogEventType["TShirtSize"] = "TSHIRT_SIZE";
    IssueChangelogEventType["Custom"] = "CUSTOM";
    IssueChangelogEventType["Unknown"] = "UNKNOWN";
})(IssueChangelogEventType = exports.IssueChangelogEventType || (exports.IssueChangelogEventType = {}));
var TaskEstimationMethod;
(function (TaskEstimationMethod) {
    TaskEstimationMethod["StoryPoints"] = "StoryPoints";
    TaskEstimationMethod["TimeBased"] = "TimeBased";
    TaskEstimationMethod["TShirtSize"] = "TShirtSize";
    TaskEstimationMethod["None"] = "None";
})(TaskEstimationMethod = exports.TaskEstimationMethod || (exports.TaskEstimationMethod = {}));
var DevelopmentMethodology;
(function (DevelopmentMethodology) {
    DevelopmentMethodology["Kanban"] = "Kanban";
    DevelopmentMethodology["Scrum"] = "Scrum";
    DevelopmentMethodology["None"] = "None";
})(DevelopmentMethodology = exports.DevelopmentMethodology || (exports.DevelopmentMethodology = {}));
exports.CUSTOMER_TYPE_TO_ACUMEN_TYPE = Object.assign({}, Object.fromEntries(Object.entries(AcumenTaskType).map(([, v]) => [v, v])), {
    ["Critical Bug"]: AcumenTaskType.Bug,
    ["Technical Feature"]: AcumenTaskType["New Feature"],
    ["Members Experience"]: AcumenTaskType.Support,
    ["Feature"]: AcumenTaskType["New Feature"],
    ["Feature Bug"]: AcumenTaskType.Bug,
    ["Technical Bug"]: AcumenTaskType.Bug,
    ["New Feature"]: AcumenTaskType["New Feature"],
    ["Feature Request"]: AcumenTaskType["New Feature"],
    ["Help"]: AcumenTaskType.Support,
    ["Improvement"]: AcumenTaskType.Improvement,
    ["Defect"]: AcumenTaskType.Bug,
    ["User Story"]: AcumenTaskType.Story,
    ["Sub-bug"]: AcumenTaskType.Bug,
    ["Vulnerability"]: AcumenTaskType.Security,
    ["Story Bug"]: AcumenTaskType.Bug,
    ["Support Ticket"]: AcumenTaskType.Support,
    ["Customer Need"]: AcumenTaskType.Support,
    ["Technical Debt"]: AcumenTaskType.Task,
    ["Enhancement"]: AcumenTaskType.Improvement,
    ["Ticket"]: AcumenTaskType.Task,
    ["Production Need"]: AcumenTaskType.Task,
    ["Procurement Req"]: AcumenTaskType.Task,
    ["General Security Request"]: AcumenTaskType.Security,
    ["Housekeeping Task"]: AcumenTaskType.Task,
    ["Security Concern"]: AcumenTaskType.Security,
    ["NDA"]: AcumenTaskType.Security,
    ["Document"]: AcumenTaskType.Documentation,
    ["Risk"]: AcumenTaskType.Security,
    ["Security vendor review"]: AcumenTaskType.Security,
    ["Infra Change"]: AcumenTaskType.Task,
    ["Security Incident"]: AcumenTaskType.Security,
    ["Bug Bounty Report"]: AcumenTaskType.Bug,
    ["Security risk"]: AcumenTaskType.Security,
    ["Performance improvement"]: AcumenTaskType.Improvement
});
exports.CUSTOMER_STATUS_TO_ACUMEN_STATUS = Object.assign({}, Object.fromEntries(Object.entries(AcumenTaskStatus).map(([, v]) => [v, v])), {
    ["Open"]: AcumenTaskStatus.Backlog,
    ["To Do"]: AcumenTaskStatus.Backlog,
    ["Reopened"]: AcumenTaskStatus.Backlog,
    ["Pending"]: AcumenTaskStatus.Backlog,
    ["Blocked"]: AcumenTaskStatus.Blocked,
    ["Canceled"]: AcumenTaskStatus.Discarded,
    ["Code Review"]: AcumenTaskStatus["Code Review"],
    ["New"]: AcumenTaskStatus.Backlog,
    ["Review"]: AcumenTaskStatus["Code Review"],
    ["QA"]: AcumenTaskStatus.Testing,
    ["Rejected"]: AcumenTaskStatus.Discarded,
    ["CR"]: AcumenTaskStatus["Code Review"],
    ["In CR"]: AcumenTaskStatus["Code Review"],
    ["Cancelled"]: AcumenTaskStatus.Discarded,
    ["Design"]: AcumenTaskStatus.Backlog,
    ["Validated"]: AcumenTaskStatus.Closed,
    ["Ready"]: AcumenTaskStatus["Selected for Development"],
    ["In Production"]: AcumenTaskStatus.Closed,
    ["Deferred"]: AcumenTaskStatus.Discarded,
    ["Approved"]: AcumenTaskStatus.Closed,
    ["Waiting for support"]: AcumenTaskStatus["Client Review"],
    ["Staging"]: AcumenTaskStatus.Done,
    ["In Design"]: AcumenTaskStatus["In Progress"],
    ["Ready for QA"]: AcumenTaskStatus["To Test"],
    ["Ready For Dev"]: AcumenTaskStatus["Selected for Development"],
    ["In Review"]: AcumenTaskStatus["Code Review"],
    ["Work in progress"]: AcumenTaskStatus["In Progress"],
    ["Ready for Review"]: AcumenTaskStatus["Code Review"],
    ["In QA"]: AcumenTaskStatus.Testing,
    ["Needs Review"]: AcumenTaskStatus["Code Review"],
    ["Coding"]: AcumenTaskStatus["In Progress"],
    ["Ice Box"]: AcumenTaskStatus.Backlog,
    ["Resolved"]: AcumenTaskStatus.Closed,
    ["In Prod"]: AcumenTaskStatus.Closed,
    ["Deployed"]: AcumenTaskStatus.Closed,
    ["Work completed"]: AcumenTaskStatus.Done,
    ["Complete"]: AcumenTaskStatus.Closed,
    ["Initial Discussion"]: AcumenTaskStatus.Backlog,
    ["Active"]: AcumenTaskStatus["In Progress"],
    ["Coding In Progress"]: AcumenTaskStatus["In Progress"],
    ["Completed"]: AcumenTaskStatus.Closed,
    ["Finished"]: AcumenTaskStatus.Closed,
    ["Waiting for Review"]: AcumenTaskStatus["Code Review"],
    ["On review"]: AcumenTaskStatus["Code Review"],
    ["Fixed"]: AcumenTaskStatus.Closed
});
function createTaskStatusGroupMapping() {
    const statuses = Object.values(AcumenTaskStatus);
    const statusGrouping = {
        [AcumenTaskStatusGroup.Backlog]: [],
        [AcumenTaskStatusGroup.InProgress]: [],
        [AcumenTaskStatusGroup.Done]: []
    };
    const conversion = (status) => {
        switch (status) {
            case AcumenTaskStatus["Selected for Development"]:
            case AcumenTaskStatus.Backlog:
                return AcumenTaskStatusGroup.Backlog;
            case AcumenTaskStatus["In Progress"]:
            case AcumenTaskStatus.Blocked:
            case AcumenTaskStatus["Code Review"]:
            case AcumenTaskStatus["To Test"]:
            case AcumenTaskStatus.Testing:
                return AcumenTaskStatusGroup.InProgress;
            case AcumenTaskStatus["Client Review"]:
            case AcumenTaskStatus.Done:
            case AcumenTaskStatus.Closed:
            case AcumenTaskStatus.Discarded:
                return AcumenTaskStatusGroup.Done;
        }
    };
    statuses.forEach(status => statusGrouping[conversion(status)].push(status));
    return statusGrouping;
}
exports.taskGroupToStatusMapping = createTaskStatusGroupMapping();
exports.taskStatusToGroupMapping = Object.fromEntries(Object
    .entries(exports.taskGroupToStatusMapping)
    .flatMap(([grouping, taskStatuses]) => taskStatuses.map(ts => [ts, grouping])));
//# sourceMappingURL=task.js.map